import { AnglesUpDown } from "@/icons/AnglesUpDown.tsx";
import {
  AspectRatio,
  aspectRatioMap,
  aspectRatioSizeMap,
} from "@/lib/helpers.ts";
import { Box, Menu, TextInput } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { Dispatch, SetStateAction } from "react";

const RatioBox = ({ width, height }: { width: number; height: number }) => {
  return (
    <div className="w-4 h-auto flex justify-center items-center">
      <Box
        className="rounded-sm shadow"
        bd="1px solid gray"
        bg="gray.4"
        w={width}
        h={height}
      ></Box>
    </div>
  );
};

export function AspectRatioSelect({
  value,
  setValue,
}: {
  value: AspectRatio;
  setValue: Dispatch<SetStateAction<AspectRatio>>;
}) {
  const matches = useMediaQuery("(min-width: 56.25em)");

  return (
    <Menu
      position={matches ? "right-start" : "bottom"}
      shadow="md"
      width={200}
      withArrow
      withinPortal
    >
      <Menu.Target>
        <TextInput
          size="md"
          styles={{
            input: { cursor: "pointer" },
          }}
          value={aspectRatioMap[value]}
          leftSection={
            <RatioBox
              width={aspectRatioSizeMap[value].width}
              height={aspectRatioSizeMap[value].height}
            />
          }
          rightSection={<AnglesUpDown />}
          label="Aspect Ratio"
          readOnly
        />
      </Menu.Target>

      <Menu.Dropdown>
        {Object.keys(aspectRatioMap).map((key) => (
          <Menu.Item
            key={key}
            onClick={() => setValue(key as AspectRatio)}
            leftSection={
              <RatioBox
                width={aspectRatioSizeMap[key as AspectRatio].width}
                height={aspectRatioSizeMap[key as AspectRatio].height}
              />
            }
          >
            {aspectRatioMap[key as AspectRatio]}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
